import styled from "styled-components";
import Palette from "@src/config/theme/palette";

export const PermanentPlaceHolder = styled.span`
  color: ${Palette.lightGreyBlue};
`;
